export default __webpack_public_path__ + "static/media/logo_all_white.bc333411.png";